import React, { FC } from 'react';

import { Container } from 'layout';
import CustomCurrentRefinements from 'common/CustomCurrentRefinements';
import Filters from 'common/Filters';
import CustomResultsHandler from 'common/Filters/CustomResultsHandler';

import CustomPoliciesAndReportsHits from './CustomPoliciesAndReportsHits';
import { PolicyDetailListingProps } from './models';

import './PolicyDetailListing.scss';

const PolicyDetailListing: FC<PolicyDetailListingProps> = ({
  searchPlaceholder,
  searchText,
  selectedFiltersText,
  documentTypesDropdownText,
  categoriesDropdownText,
  numberOfResultsText,
  clearFiltersText,
  loadMoreButtonText,
  noResultsText,
  mostViewedBoxes,
  viewPageLinkText,
  pdfDownloadLinkText,
}) => (
  <>
    <Filters
      searchBtnText={searchText}
      selectedFiltersText={selectedFiltersText}
      searchPlaceholder={searchPlaceholder}
      firstFilterText={documentTypesDropdownText}
      secondFilterText={categoriesDropdownText}
      filters={['documentType', 'category.name']}
      numberOfResultsText={numberOfResultsText}
      clearFiltersText={clearFiltersText}
      mostViewedBoxes={mostViewedBoxes}
    />
    <Container>
      <CustomCurrentRefinements />
    </Container>
    <CustomResultsHandler noResultsText={noResultsText}>
      <CustomPoliciesAndReportsHits
        loadMoreText={loadMoreButtonText}
        viewPageLinkText={viewPageLinkText}
        pdfDownloadLinkText={pdfDownloadLinkText}
      />
    </CustomResultsHandler>
  </>
);

export default PolicyDetailListing;
